import { firestore } from '~/firebase/init';
import { doc, collection, onSnapshot, where, documentId, query } from 'firebase/firestore';

import { SnapshotFn, CollectionSnapShotFn } from './type';

export function storeListListener(storeList: Array<string>, onNext: CollectionSnapShotFn) {
  const ref = collection(firestore, 'stores');

  return onSnapshot(query(ref, where(documentId(), 'in', storeList)), {
    next: onNext,
    error: () => {
      console.error('listen store list error');
    },
  });
}

export function storeListener(storeId: string, onNext: SnapshotFn) {
  const ref = doc(firestore, 'stores', storeId);
  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error('listen store data error');
    },
  });
}

export function storeMenusListener(storeId: string, onNext: CollectionSnapShotFn) {
  const ref = collection(firestore, 'stores', storeId, 'menus');

  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error('listen store menus error');
    },
  });
}

export function storeCategoriesListener(storeId: string, onNext: CollectionSnapShotFn) {
  const ref = collection(firestore, 'stores', storeId, 'categories');

  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error('listen store category error');
    },
  });
}

export function storeItemsListener(storeId: string, onNext: CollectionSnapShotFn) {
  const ref = collection(firestore, 'stores', storeId, 'items');

  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error('listen store items error');
    },
  });
}
